/* Native Oak & Lily cart with Optimistic UI, Stepper Debouncing & Micro-DOM Patching */
(()=>{
if(window.oakNativeCartReady)return;window.oakNativeCartReady=true;
const root=window.Shopify?.routes?.root||'/';
let previousLevel=null;
const pendingChangeTimers={};
const pendingQuantities={};

const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:2}).format(n/100);
const formatInr=n=>'₹ '+new Intl.NumberFormat('en-IN',{maximumFractionDigits:2,minimumFractionDigits:2}).format(n/100);

function milestones(celebrateFrom=null,customSavings=null){
 const box=document.querySelector('[data-cart-rewards]');if(!box)return;
 const total=Number(box.dataset.cartTotal)||0,tiers=box.dataset.thresholds.split(',').map(Number),positions=[100/6,50,500/6];
 const level=tiers.filter(t=>total>=t).length;let progress=100;
 for(let i=0;i<tiers.length;i++){if(total<tiers[i]){const a=i?tiers[i-1]:0,b=i?positions[i-1]:0;progress=b+(total-a)/(tiers[i]-a)*(positions[i]-b);break;}}
 const fill=box.querySelector('[data-reward-fill]');
 if(fill)fill.style.width=Math.max(0,Math.min(100,progress))+'%';
 box.querySelectorAll('[data-reward-node]').forEach((node,i)=>node.classList.toggle('is-unlocked',total>=tiers[i]));
 const names=['10% OFF','Free Napkins','Gift Hamper'];
 const headline=box.querySelector('[data-reward-headline]');
 if(headline){
  headline.textContent=level===3?'You have unlocked all reward milestones!':'Get '+names[level]+' by adding items worth '+money(Math.max(0,tiers[level]-total));
 }
 if(celebrateFrom!==null&&level>celebrateFrom)triggerCelebration(level,customSavings);
 previousLevel=level;
}

function clearStatus(){
 document.querySelector('[data-cart-status]')?.remove();
}

function message(text){
 clearStatus();
 if(!text)return;
 const el=document.createElement('p');el.dataset.cartStatus='';el.setAttribute('role','status');
 el.style.cssText='margin:8px 15px;color:#103f56;font-size:13px';
 document.querySelector('.cart-coupon-box')?.after(el);
 el.textContent=text;
 setTimeout(()=>el.remove(),4000);
}

const CONFETTI_COLORS=['#E9BF20','#2E7D32','#123F57','#F4D35E','#B7EBC8','#FFFFFF'];
let confettiFrame=null,confettiParticles=[],confettiStart=0;
function stopConfetti(){
 if(confettiFrame)cancelAnimationFrame(confettiFrame);
 confettiFrame=null;confettiParticles=[];
 const canvas=document.querySelector('#celebration-confetti-canvas');
 if(canvas){const ctx=canvas.getContext('2d');ctx.clearRect(0,0,canvas.width,canvas.height);}
}

function startConfetti(){
 stopConfetti();
 const canvas=document.querySelector('#celebration-confetti-canvas'),drawer=document.querySelector('#CartDrawer');
 if(!canvas||!drawer||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const rect=drawer.getBoundingClientRect(),dpr=Math.min(window.devicePixelRatio||1,2);
 canvas.width=Math.max(1,Math.floor(rect.width*dpr));canvas.height=Math.max(1,Math.floor(rect.height*dpr));
 const ctx=canvas.getContext('2d');ctx.scale(dpr,dpr);
 const w=rect.width,h=rect.height;
 confettiParticles=Array.from({length:65},(_,i)=>({
  x:Math.random()*w,y:-20-Math.random()*h*.3,
  vx:(Math.random()-.5)*1.6,vy:2.4+Math.random()*2.8,
  size:5+Math.random()*6,rotation:Math.random()*Math.PI*2,
  vr:(Math.random()-.5)*.16,wobble:Math.random()*Math.PI*2,
  color:CONFETTI_COLORS[i%CONFETTI_COLORS.length],alpha:1
 }));
 confettiStart=performance.now();
 const draw=now=>{
  const elapsed=now-confettiStart;
  ctx.clearRect(0,0,w,h);
  confettiParticles.forEach(p=>{
   p.x+=p.vx+Math.sin(p.wobble+elapsed*.004)*.4;
   p.y+=p.vy;p.vy=Math.min(p.vy+.03,5.2);
   p.rotation+=p.vr;p.wobble+=.03;
   if(elapsed>2400)p.alpha=Math.max(0,1-(elapsed-2400)/800);
   if(p.y>h+20)p.y=-20;
   ctx.save();ctx.globalAlpha=p.alpha;ctx.translate(p.x,p.y);ctx.rotate(p.rotation);
   ctx.fillStyle=p.color;ctx.fillRect(-p.size/2,-p.size*.32,p.size,p.size*.64);ctx.restore();
  });
  if(elapsed<3200)confettiFrame=requestAnimationFrame(draw);else stopConfetti();
 };
 confettiFrame=requestAnimationFrame(draw);
}

function triggerCelebration(level,customSavings=null){
 const sheet=document.querySelector('#milestone-celebration');if(!sheet)return;
 const names=['10% OFF','Free Napkins','Gift Hamper'];
 const copy=[
  ['Woohoo!','You just unlocked 10% OFF!'],
  ['Woohoo!','You just got a free gift with your purchase!'],
  ['Woohoo!','You just got a free gift with your purchase!']
 ][Math.max(0,Math.min(2,level-1))];
 sheet.querySelector('[data-celebration-headline]').textContent=copy[0];
 sheet.querySelector('[data-celebration-subline]').textContent=copy[1];
 sheet.querySelector('[data-celebration-reward]').textContent=names[Math.max(0,Math.min(2,level-1))];
 const savings=sheet.querySelector('[data-celebration-savings]');
 const couponVal=document.querySelector('[data-coupon-savings-val]')?.textContent?.trim();
 const footerVal=document.querySelector('[data-footer-savings-val]')?.textContent?.trim();
 const cartSavings=customSavings||(couponVal&&couponVal!=='₹ 0.00'?couponVal:footerVal);
 if(savings&&cartSavings)savings.textContent=cartSavings;
 sheet.classList.add('is-active');sheet.setAttribute('aria-hidden','false');
 startConfetti();
 const button=sheet.querySelector('[data-celebration-dismiss]');button?.focus();
}

function dismissCelebration(){
 const sheet=document.querySelector('#milestone-celebration');sheet?.classList.remove('is-active');sheet?.setAttribute('aria-hidden','true');stopConfetti();
}

function syncOptimisticCart(clickedCard,itemKey,targetQty){
 const qtyEl=clickedCard.querySelector('[data-item-qty]');
 if(qtyEl)qtyEl.textContent=targetQty;
 clickedCard.style.opacity=targetQty===0?'0.35':'1';

 const box=document.querySelector('[data-cart-rewards]');
 const tiers=box?box.dataset.thresholds.split(',').map(Number):[110000,159900,299900];
 const allCards=document.querySelectorAll('.cart-item-card');

 let totalSubtotal=0;
 let totalCompare=0;
 let totalItemCount=0;

 allCards.forEach(c=>{
  const key=c.dataset.lineItemKey;
  const q=(key===itemKey)?targetQty:(pendingQuantities[key]!==undefined?pendingQuantities[key]:(Number(c.querySelector('[data-item-qty]')?.textContent)||0));
  if(q<=0)return;
  totalItemCount+=q;
  const origU=Number(c.dataset.originalUnitPrice||c.dataset.unitPrice)||0;
  const compU=Number(c.dataset.compareUnitPrice)||origU;
  totalSubtotal+=q*origU;
  totalCompare+=q*(compU>origU?compU:origU);
 });

 // Milestone progress tracks subtotal so discounts never push customer backwards!
 const tier1Threshold=tiers[0]||110000;
 const isTier1Unlocked=totalSubtotal>=tier1Threshold;

 // Proportional coupon discount (10% if subtotal >= tier1)
 const autoCouponDiscount=isTier1Unlocked?Math.round(totalSubtotal*0.10):0;
 const finalGrandTotal=Math.max(0,totalSubtotal-autoCouponDiscount);
 const mrpDiscount=Math.max(0,totalCompare-totalSubtotal);
 const totalSavings=Math.max(0,totalCompare-finalGrandTotal);

 // Update all cards
 allCards.forEach(c=>{
  const key=c.dataset.lineItemKey;
  const q=(key===itemKey)?targetQty:(pendingQuantities[key]!==undefined?pendingQuantities[key]:(Number(c.querySelector('[data-item-qty]')?.textContent)||0));
  if(q<=0)return;
  const origU=Number(c.dataset.originalUnitPrice||c.dataset.unitPrice)||0;
  const compU=Number(c.dataset.compareUnitPrice)||origU;
  const isGift=c.classList.contains('cart-item-card--gift')||origU===0;

  // Final line price
  const linePriceEl=c.querySelector('[data-line-price]');
  if(linePriceEl&&!isGift){
   const lineFinal=isTier1Unlocked?Math.round(origU*0.90*q):(origU*q);
   linePriceEl.textContent=formatInr(lineFinal);
  }

  // Compare line price
  const comparePriceEl=c.querySelector('[data-compare-line-price]');
  if(comparePriceEl){
   const lineCompare=(compU>origU?compU:origU)*q;
   const currentLinePrice=isTier1Unlocked?Math.round(origU*0.90*q):(origU*q);
   if(lineCompare>currentLinePrice){
    comparePriceEl.textContent=formatInr(lineCompare);
    comparePriceEl.style.display='';
   }else{
    comparePriceEl.style.display='none';
   }
  }
 });

 // Rewards Bar & Celebration trigger
 if(box){
  const levelBefore=previousLevel!==null?previousLevel:tiers.filter(t=>(Number(box.dataset.cartTotal)||0)>=t).length;
  box.dataset.cartTotal=totalSubtotal;
  const explicitSavings=autoCouponDiscount>0?formatInr(autoCouponDiscount):formatInr(totalSavings);
  milestones(levelBefore,explicitSavings);
 }

 // Counts
 const countEl=document.querySelector('[data-cart-count]');
 if(countEl)countEl.textContent=`(${totalItemCount})`;
 const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span');
 if(bubble)bubble.textContent=totalItemCount;

 // Footer totals
 const footerFinal=document.querySelector('[data-footer-final-total]');
 if(footerFinal)footerFinal.textContent=formatInr(finalGrandTotal);

 const footerOld=document.querySelector('[data-footer-old-total]');
 if(footerOld){
  if(totalSavings>0){
   footerOld.textContent=formatInr(totalCompare);
   footerOld.style.display='';
  }else{
   footerOld.textContent='';
   footerOld.style.display='none';
  }
 }

 const footerSavingsRow=document.querySelector('[data-footer-savings-row]');
 const footerSavingsVal=document.querySelector('[data-footer-savings-val]');
 if(footerSavingsRow&&footerSavingsVal){
  if(totalSavings>0){
   footerSavingsVal.textContent=formatInr(totalSavings);
   footerSavingsRow.style.display='';
  }else{
   footerSavingsRow.style.display='none';
  }
 }

 // Coupon Box
 const couponSavingsVal=document.querySelector('[data-coupon-savings-val]');
 if(couponSavingsVal){
  couponSavingsVal.textContent=formatInr(autoCouponDiscount);
 }
 const couponSavingsRow=document.querySelector('.cart-coupon-box__savings-row');
 if(couponSavingsRow){
  couponSavingsRow.style.display=autoCouponDiscount>0?'':'none';
 }
 const couponDetails=document.querySelector('#CartDiscountDetails');
 if(couponDetails&&autoCouponDiscount===0){
  couponDetails.hidden=true;
 }

 // Breakdown Details Accordion
 const breakdownMrp=document.querySelector('[data-breakdown-mrp]');
 if(breakdownMrp)breakdownMrp.textContent=formatInr(totalCompare);

 const breakdownMrpDiscount=document.querySelector('[data-breakdown-mrp-discount]');
 if(breakdownMrpDiscount)breakdownMrpDiscount.textContent=formatInr(mrpDiscount);

 const breakdownCoupon=document.querySelector('[data-breakdown-coupon-discount]');
 if(breakdownCoupon)breakdownCoupon.textContent=formatInr(autoCouponDiscount);

 const breakdownGrand=document.querySelector('[data-breakdown-grand-total]');
 if(breakdownGrand)breakdownGrand.textContent=formatInr(finalGrandTotal);

 const breakdownHeader=document.querySelector('[data-breakdown-header-savings]');
 if(breakdownHeader)breakdownHeader.textContent=`You saved ${formatInr(totalSavings)}!`;

 const breakdownSaved=document.querySelector('[data-breakdown-saved-banner]');
 if(breakdownSaved&&totalCompare>0){
  const pct=((totalSavings/totalCompare)*100).toFixed(1);
  breakdownSaved.textContent=`You Saved ${formatInr(totalSavings)} (${pct}%) so far!`;
 }
}

async function render(html){
 const doc=new DOMParser().parseFromString(html,'text/html');
 const fresh=doc.querySelector('#CartDrawer');
 const old=document.querySelector('#CartDrawer');
 if(!fresh||!old)throw Error('Cart could not refresh. Please reload.');

 const levelBefore=previousLevel;
 const oldCards=old.querySelectorAll('.cart-item-card');
 const freshCards=fresh.querySelectorAll('.cart-item-card');
 const hasEmpty=fresh.querySelector('.drawer__inner-empty')||old.querySelector('.drawer__inner-empty');

 // Micro-DOM Patching if items structure is stable
 if(oldCards.length>0&&oldCards.length===freshCards.length&&!hasEmpty){
  freshCards.forEach((freshCard,idx)=>{
   const oldCard=oldCards[idx];
   if(oldCard){
    const freshKey=freshCard.dataset.lineItemKey;
    oldCard.dataset.lineItemKey=freshKey;
    if(freshCard.dataset.unitPrice)oldCard.dataset.unitPrice=freshCard.dataset.unitPrice;
    if(freshCard.dataset.originalUnitPrice)oldCard.dataset.originalUnitPrice=freshCard.dataset.originalUnitPrice;
    if(freshCard.dataset.compareUnitPrice)oldCard.dataset.compareUnitPrice=freshCard.dataset.compareUnitPrice;
    oldCard.querySelectorAll('[data-cart-qty-change]').forEach(btn=>btn.dataset.itemKey=freshKey);
    oldCard.querySelectorAll('[data-cart-remove]').forEach(btn=>btn.dataset.cartRemove=freshKey);

    if(pendingQuantities[freshKey]===undefined){
     const freshQty=freshCard.querySelector('[data-item-qty]')?.textContent;
     const oldQty=oldCard.querySelector('[data-item-qty]');
     if(oldQty&&freshQty)oldQty.textContent=freshQty;
     oldCard.style.opacity='1';

     const freshPrice=freshCard.querySelector('[data-line-price]')?.innerHTML;
     const oldPrice=oldCard.querySelector('[data-line-price]');
     if(oldPrice&&freshPrice)oldPrice.innerHTML=freshPrice;

     const freshOldPrice=freshCard.querySelector('[data-compare-line-price]')?.innerHTML;
     const oldOldPrice=oldCard.querySelector('[data-compare-line-price]');
     if(oldOldPrice){
      if(freshOldPrice){
       oldOldPrice.innerHTML=freshOldPrice;
       oldOldPrice.style.display='';
      }else{
       oldOldPrice.style.display='none';
      }
     }
    }
   }
  });

  const oldCouponBox=old.querySelector('[data-cart-coupon-box]');
  const freshCouponBox=fresh.querySelector('[data-cart-coupon-box]');
  if(oldCouponBox&&freshCouponBox&&Object.keys(pendingQuantities).length===0){
   const oldSavingsRow=oldCouponBox.querySelector('.cart-coupon-box__savings-row');
   const freshSavingsRow=freshCouponBox.querySelector('.cart-coupon-box__savings-row');
   if(oldSavingsRow&&freshSavingsRow)oldSavingsRow.style.display=freshSavingsRow.style.display;

   const oldVal=oldCouponBox.querySelector('[data-coupon-savings-val]');
   const freshVal=freshCouponBox.querySelector('[data-coupon-savings-val]');
   if(oldVal&&freshVal)oldVal.innerHTML=freshVal.innerHTML;

   const oldDet=oldCouponBox.querySelector('#CartDiscountDetails');
   const freshDet=freshCouponBox.querySelector('#CartDiscountDetails');
   if(oldDet&&freshDet)oldDet.innerHTML=freshDet.innerHTML;
  }

  const oldFooter=old.querySelector('.drawer__footer-wrap');
  const freshFooter=fresh.querySelector('.drawer__footer-wrap');
  if(oldFooter&&freshFooter&&Object.keys(pendingQuantities).length===0){
   const oldFinal=oldFooter.querySelector('[data-footer-final-total]');
   const freshFinal=freshFooter.querySelector('[data-footer-final-total]');
   if(oldFinal&&freshFinal)oldFinal.innerHTML=freshFinal.innerHTML;

   const oldOld=oldFooter.querySelector('[data-footer-old-total]');
   const freshOld=freshFooter.querySelector('[data-footer-old-total]');
   if(oldOld&&freshOld){oldOld.innerHTML=freshOld.innerHTML;oldOld.style.display=freshOld.style.display;}

   const oldRow=oldFooter.querySelector('[data-footer-savings-row]');
   const freshRow=freshFooter.querySelector('[data-footer-savings-row]');
   if(oldRow&&freshRow){oldRow.innerHTML=freshRow.innerHTML;oldRow.style.display=freshRow.style.display;}

   const oldBrk=oldFooter.querySelector('.cart-total-breakdown');
   const freshBrk=freshFooter.querySelector('.cart-total-breakdown');
   if(oldBrk&&freshBrk){
    const wasOpen=oldBrk.hasAttribute('open');
    const oldBdy=oldBrk.querySelector('.cart-total-breakdown__body');
    const freshBdy=freshBrk.querySelector('.cart-total-breakdown__body');
    if(oldBdy&&freshBdy)oldBdy.innerHTML=freshBdy.innerHTML;
    if(wasOpen)oldBrk.setAttribute('open','');
   }
  }

  const oldRew=old.querySelector('[data-cart-rewards]');
  const freshRew=fresh.querySelector('[data-cart-rewards]');
  if(oldRew&&freshRew&&Object.keys(pendingQuantities).length===0){
   oldRew.dataset.cartTotal=freshRew.dataset.cartTotal;
  }

  const count=fresh.querySelector('[data-cart-count]')?.textContent.replace(/[^0-9]/g,'')||'0';
  const countEl=old.querySelector('[data-cart-count]');
  if(countEl&&Object.keys(pendingQuantities).length===0)countEl.textContent=`(${count})`;
  const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span');
  if(bubble&&Object.keys(pendingQuantities).length===0)bubble.textContent=count;

  clearStatus();
  if(levelBefore!==null)milestones(levelBefore);
  else milestones();
 } else {
  // Structural changes (items added, removed, empty state)
  const pos=old.querySelector('.cart-drawer__scroll')?.scrollTop||0;
  old.innerHTML=fresh.innerHTML;
  const scroller=old.querySelector('.cart-drawer__scroll');
  if(scroller)scroller.scrollTop=pos;
  const count=old.querySelector('[data-cart-count]')?.textContent.replace(/[^0-9]/g,'')||'0';
  document.querySelector('cart-drawer')?.classList.toggle('is-empty',count==='0');
  const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span');
  if(bubble)bubble.textContent=count;
  clearStatus();
  if(levelBefore!==null)milestones(levelBefore);
  else milestones();
 }
}

async function refresh(){
 const res=await fetch(root+'?section_id=cart-drawer');
 if(!res.ok)throw Error('Unable to refresh cart');
 await render(await res.text());
}

async function change(endpoint,payload){
 try{
  const res=await fetch(root+endpoint,{
   method:'POST',
   headers:{'Content-Type':'application/json',Accept:'application/json'},
   body:JSON.stringify({...payload,sections:['cart-drawer']})
  });
  const data=await res.json();
  if(!res.ok){
   await refresh();
   return;
  }
  if(data.sections?.['cart-drawer'])await render(data.sections['cart-drawer']);
  else await refresh();
 }catch(err){
  await refresh();
 }
}

document.addEventListener('click',async e=>{
 if(e.target.matches('#milestone-celebration')||e.target.closest('[data-celebration-dismiss]')){dismissCelebration();return;}

 // 1. Optimistic Stepper with Debounced Queue
 const step=e.target.closest('[data-cart-qty-change]');
 if(step){
  e.preventDefault();
  if(step.disabled)return;
  const card=step.closest('.cart-item-card');
  const itemKey=step.dataset.itemKey;
  if(!card||!itemKey)return;

  const currentDisplayQty=Number(card.querySelector('[data-item-qty]')?.textContent)||0;
  const currentWorkingQty=pendingQuantities[itemKey]!==undefined?pendingQuantities[itemKey]:currentDisplayQty;
  const delta=Number(step.dataset.cartQtyChange)||0;
  const targetQty=Math.max(0,currentWorkingQty+delta);
  if(targetQty===currentWorkingQty)return;

  pendingQuantities[itemKey]=targetQty;

  // Immediate 0ms Comprehensive Visual Update
  syncOptimisticCart(card,itemKey,targetQty);

  // Debounced Network Dispatch (250ms window)
  clearTimeout(pendingChangeTimers[itemKey]);
  pendingChangeTimers[itemKey]=setTimeout(async ()=>{
   const qtyToSend=pendingQuantities[itemKey];
   try{
    await change('cart/change.js',{id:itemKey,quantity:qtyToSend});
   }finally{
    delete pendingQuantities[itemKey];
    delete pendingChangeTimers[itemKey];
   }
  },250);
  return;
 }

 // 2. Item Removal
 const remove=e.target.closest('[data-cart-remove]');
 if(remove){
  e.preventDefault();
  const card=remove.closest('.cart-item-card');
  if(card){
   card.style.opacity='0.3';
   card.style.pointerEvents='none';
  }
  await change('cart/change.js',{id:remove.dataset.cartRemove,quantity:0});
  return;
 }

 // 3. Quick-Add
 const add=e.target.closest('[data-quick-add]');
 if(add){
  e.preventDefault();
  if(add.disabled)return;
  add.disabled=true;
  const origText=add.textContent;
  add.textContent='ADDING…';
  try{
   await change('cart/add.js',{items:[{id:Number(add.dataset.quickAdd),quantity:1}]});
  }finally{
   if(add.isConnected){
    add.disabled=false;
    add.textContent=origText;
   }
  }
  return;
 }

 // 4. Recommendations Carousel Scroll
 const nav=e.target.closest('[data-rec-prev],[data-rec-next]');
 if(nav){
  e.preventDefault();
  const grid=nav.closest('.cart-recs-box').querySelector('[data-rec-grid]');
  if(grid)grid.scrollBy({left:grid.clientWidth*(nav.hasAttribute('data-rec-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  return;
 }

 // 5. Coupon Box Toggle
 const toggle=e.target.closest('[data-coupon-toggle]');
 if(toggle){
  const details=document.querySelector('[data-discount-details]');
  if(details){details.hidden=!details.hidden;toggle.setAttribute('aria-expanded',String(!details.hidden));}
  return;
 }

 // 6. Coupon Apply
 if(e.target.closest('[data-coupon-apply]')){
  e.preventDefault();
  const code=document.querySelector('[data-coupon-input]')?.value.trim();
  if(!code){message('Enter a coupon code first.');return;}
  await change('cart/update.js',{discount:code});
  message('Coupon checked. Eligible discounts are reflected in your cart and checkout.');
 }
});

document.addEventListener('keydown',e=>{
 if(e.key==='Escape'&&document.querySelector('#milestone-celebration.is-active'))dismissCelebration();
});

document.addEventListener('cart:updated',()=>{
 if(Object.keys(pendingQuantities).length===0)refresh();
});

new MutationObserver(ms=>{
 if(ms.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-cart-rewards]')||n.querySelector?.('[data-cart-rewards]')))))milestones();
}).observe(document.documentElement,{childList:true,subtree:true});

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>milestones());else milestones();
})();
